module.exports = __webpack_public_path__ + "img/tabs-bg.5fcda123.png";